export const selectUserInfo = state => state.userInfo.user;
export const userId = state => state.auth.userId;
export const selectDailyNormaInfo = state => state.userInfo.daylyNorm;

export const selectWaterRate = state => state.user.waterRate;


